import React, { useEffect, useState } from 'react'
import useRequestForgotPassword from '../../Hooks/useRequestForgotPassword';
import Email from './Email';
import resetPassword from '../../Assets/forgotPassword/resetPassword.svg';
import logo from '../../Assets/logo.png'
import { ButtonWithoutIcon, Loader } from '../../constents/components';
import OtpPage from './OtpPage';

const ForgotPassword = () => {
    const [loading, error, success, requestFunction] = useRequestForgotPassword();
    const [email, setEmail] = useState('');
    const [emailValidation, setEmailValidation] = useState(false);
    const [otpPage, setShowOtpPage] = useState(false);

    const submitRequest = async (e) => {
        e.preventDefault();
        try {
            const response = await requestFunction(email);
        }
        catch (err) {

        }
    }

    useEffect(() => {
        if (success) {
            setShowOtpPage(true);
        }
    }, [success, email]);

    if (otpPage) {
        return <OtpPage email={email} />
    }

    return (
        <div className='h-screen w-screen flex flex-col md:flex-row'>
            <div className='bg-pills-bg-color-900 flex flex-col items-center py-4 px-4 md:w-1/2 md:justify-center'>
                <div className='mb-2 md:mb-6'>
                    <img src={logo} alt="Zepcruit logo" className='h-8 md:hidden md:h-10' />
                </div>
                <div className='w-full max-w-md my-4 md:my-8'>
                    <img src={resetPassword} alt="Reset password illustration" className='w-44 max-w-xs mx-auto md:w-96' />
                </div>
                <h2 className='text-2xl font-semibold text-center mt-4 mb-1 md:text-3xl'>Jobs That Get You</h2>
                <p className='text-text-color-strong text-xs text-center md:text-base'>
                    (Because Algorithms Are Smarter Than Your Ex)
                </p>
            </div>


            <div className='flex-1 flex flex-col items-center justify-between px-4 py-6 bg-white-bg-color md:w-1/2 md:py-20'>
                <div className='w-full max-w-md md:max-w-lg'>

                    <div className='hidden md:block md:text-center md:mb-10'>
                        <img src={logo} alt="Zepcruit logo" className='h-10 inline-block' />
                    </div>

                    <h3 className='text-2xl font-bold text-center mb-2 md:text-3xl'>Reset Password</h3>
                    <p className='md:block text-text-color-strong text-xs text-center mb-6'>
                        Begin your journey toward landing your dream job!
                    </p>
                    {/* <p className='hidden md:block text-text-color-strong text-xs text-center mb-6 md:mb-8'>
                        We have sent code to your email <span className='font-bold'>@zepcruit.com</span>
                    </p> */}

                    <form onSubmit={submitRequest} className='w-full'>
                        <div className='mb-2 md:mb-4'>
                            <Email
                                email={email}
                                setEmail={setEmail}
                                setEmailValid={setEmailValidation}
                            />
                        </div>
                        {error && (<p className=' text-red-500 text-xs'>{error}</p>)}

                        <div className='mt-auto pt-20 md:pt-16 w-full'>
                            {
                                loading ? <Loader /> :
                                    <ButtonWithoutIcon
                                        classNames='w-full text-white-bg-color py-4 px-6 rounded-full font-medium bg-black hover:bg-gray-800'
                                        text='Reset Password'
                                        loading={loading}
                                        type="submit"
                                    // onClick={submitRequest}
                                    />
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword;